import React from 'react';
import { PreFilterDatatableList, RowSelectionAction } from '@europrocurement/flexy-datatable';
import {
    LimitAccessFilterApiMultipleFactureOpenSearch,
    useFactureColumns,
    useFactureFilters,
    usePanierPay,
} from '@europrocurement/l2d-modules';
import { FactureStatus } from '@europrocurement/l2d-modules/modules/Factures/hooks/useFactureFilters';
import { FactureOpenSearch } from '@europrocurement/l2d-domain';
import { useSnackbar } from 'notistack';
import ActionMenuListeFacture from '../views/liste/ActionMenu/ActionMenuListeFacture';

const useFactureTable = ({
    prescriberIdRef,
    ddmIdFilter,
}: LimitAccessFilterApiMultipleFactureOpenSearch) => {
    const { columnsFront } = useFactureColumns();
    const { factureFiltersFront } = useFactureFilters({ prescriberIdRef, ddmIdFilter });

    const { navigateFacturePay } = usePanierPay();
    const { enqueueSnackbar } = useSnackbar();
    columnsFront.push({
        label: 'Actions',
        displayLabel: false,
        render: (facture: FactureOpenSearch) => <ActionMenuListeFacture facture={facture} />,
        isDisplayed: true,
        sortable: false,
        sx: {
            display: {
                xs: 'none',
                sm: 'none',
                md: 'table-cell',
                lg: 'table-cell',
                xl: 'table-cell',
            },
        },
    });
    const rowActions: RowSelectionAction[] = [
        {
            icon: 'fa-credit-card',
            label: 'Payer ces factures',
            onClick: (items: Array<FactureOpenSearch>) => {
                if (!items || items.length === 0) return;

                // Vérifie que tous les clientId sont identiques
                const clientIds = items.map((item) => item.clientId);
                const uniqueClientIds = Array.from(new Set(clientIds));
                if (uniqueClientIds.length > 1) {
                    enqueueSnackbar(
                        'Erreur : les factures sélectionnées doivent être facturées au même client.',
                        { variant: 'error' },
                    );
                    return;
                }

                const ids = items.map((item) => item.id);

                navigateFacturePay(ids);
            },
        },
    ];

    const preFilters: PreFilterDatatableList = {
        label: 'Filtrer par statuts',
        items: [
            {
                label: 'Tout',
                filters: [],
            },
            {
                label: 'A régler',
                filters: [{ field: 'status', value: FactureStatus.TO_PAY }],
            },
            {
                label: 'En retard',
                filters: [{ field: 'status', value: FactureStatus.LATE }],
            },
            {
                label: 'Réglée',
                filters: [{ field: 'status', value: FactureStatus.PAYED }],
            },
        ],
    };

    return { columns: columnsFront, filters: factureFiltersFront, preFilters, rowActions };
};

export default useFactureTable;
